import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, Form, Button, Row, Col, ToggleButton, Modal, ToggleButtonGroup, Spinner, InputGroup } from "react-bootstrap";
import axios from "axios";
import SignatureCanvas from "react-signature-canvas";
import { toast } from "react-toastify";
import Select from 'react-select';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Driver from '../../assets/images/driver.png';
import Visitor from '../../assets/images/visitor.png';
import logo from '../../assets/images/cargohub-logo.png';
import driver_img from '../../assets/images/driver_img.png';
import visitor_img from '../../assets/images/visitor_img.png';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import phonePrefixes from '../../Utils/phonePrefixes.json';
import loading_icon from '../../assets/images/truck_loading.png';
import unloading_icon from '../../assets/images/truck_unloading.png';

import { withoutRFSToken, withDVRToken } from '../../Services/axios.js';
import { decrypt } from '../../Utils/cryptoStorage.js';

const DriverVisitorRegistration = () => {

  const isMounted = useRef(false);
  const [view, setView] = useState("menu");
  const [searchText, setSearchText] = useState("");
  const [loadingType, setLoadingType] = useState();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [signatureMode, setSignatureMode] = useState("draw");
  const [typedSignature, setTypedSignature] = useState("");
  const [userList, setUserList] = useState([]);
  const sigPadRef = useRef(null);
  const [authData, setAuthData] = useState();
  let token = localStorage.NO_TOKEN;
  // const person = localStorage.getItem('person');
  // const key = localStorage.getItem('key');
  // const orgLogo = localStorage.getItem('orgLogo');
  // const orgName = localStorage.getItem('OrgName');
  const [loading, setLoading] = useState(false);

  const [driverForm, setDriverForm] = useState({
    company_name: "",
    first_name: "",
    surname: "",
    id_number: "",
    id_type: "",
    license: "",
    number: "",
    // phone: "",
    loading_or_unloading: "",
  });

  const [visitorForm, setVisitorForm] = useState({
    visitor_name: "",
    surname: "",
    company_name: "",
    license: "",
    person_to_meet: "",
    arrived_with_car: "",
    status: "1",
  });

  const [dialCode, setDialCode] = useState();
  const phoneOptions = (phonePrefixes).map(p => ({
    value: p.dialCode,
    label: `${p.dialCode} - ${p.isoCode}`,
    isoCode: p.isoCode
  }));

  const filterPhoneOption = (candidate, rawInput) => {
    const input = (rawInput || '').trim();
    if (!input) return true;
    const digits = input.replace(/\D/g, '');
    const label = candidate.label.toLowerCase();
    const iso = (candidate.data?.isoCode || '').toLowerCase();
    // If user typed numbers → match dial code digits
    if (digits) {
      const optionDigits = String(candidate.value).replace(/\D/g, '');
      return optionDigits.includes(digits);
    }
    // Else match iso code or label text
    return iso.includes(input.toLowerCase()) || label.includes(input.toLowerCase());
  };
  const idTypeOptions = [
    { value: "Driver License", label: "Driver License" },
    { value: 'Passport', label: 'Passport' },
  ];


  const fetchSettings = async () => {
    try {
      const res = await withDVRToken.get('get-authorize-user');
      const innerData = res?.data?.response_data;
      const trData = innerData.map(dta => ({ id: dta.value, name: dta.label }))
      setUserList(innerData || [])
    } catch (error) {
      console.error('Error fetching settings:', error);
      // toast.error('Failed to load settings');
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    const ExtractSession = async () => {
      try {
        const encryptedData = sessionStorage.getItem('__A-');

        if (encryptedData) {
          const data = await decrypt(encryptedData);

          setAuthData(data);
        }
      } catch (error) {
        console.error("Session decrypt error:", error);
      } finally {
        // setAuthLoading(false);
      }
    };

    ExtractSession();
    fetchSettings()
    isMounted.current = true;
  }, []);

  const cards = [
    { title: 'Driver Registration', name: 'driver', sub: 'Please share your details to complete driver registration', img: driver_img },
    { title: 'Visitor Registration', name: 'visitor', sub: 'Please share your details to complete visitor registration', img: visitor_img }
  ];
  const visibleCards = (
    authData?.person === 'D'
      ? cards.filter((c) => c.name === 'driver')
      : authData?.person === 'V'
        ? cards.filter((c) => c.name === 'visitor')
        : authData?.person === 'B'
          ? cards
          : cards
  );
  const visitorFields = [
    { label: 'Company', type: 'text', name: 'company_name', ph: 'Company name' },
    { label: 'Visitor Name', type: 'text', name: 'visitor_name', ph: 'Visitor name' },
    // { label: 'Phone No.', type: 'tel', name: 'number', ph: 'Phone No.' },
  ];

  const handleOnSearch = (string, results) => {
    const searchWord = string.trim().toLowerCase()
    if (!searchWord) return []

    return userList.filter((item) =>
      item.name.toLowerCase().split(" ").includes(searchWord)
    )
    // const cleaned = string.trim().toLowerCase();
    // const filtered = userList.filter(item =>
    //   item.name.toLowerCase().includes(cleaned)
    // );
    // console.log("Filtered:", filtered);
  };
  const handleOnHover = (result) => {
    // the item hovered
    console.log(result)
  }
  const handleOnFocus = () => {
    // console.log('Focused')
  }
  const handleOnSelect = async (item) => {
    setVisitorForm((prev) => ({ ...prev, 'person_to_meet': item.name, 'appointment_with': item.id }));
  }

  const customFilter = (option, inputValue) => {
    if (!inputValue) return true
    const words = option.label.toLowerCase().split(" ")
    return words.some(word => word.startsWith(inputValue.toLowerCase()))
  }


  const cardClick = (nam) => {
    if (nam === 'driver') {
      setView('driver');
    } else {
      setView('visitor');
    }
    setSignatureMode('draw');
  }

  const handleDriverChange = (e) => {
    const { name, value } = e.target;
    setDriverForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleVisitorChange = (e) => {
    const { name, value } = e.target;
    setVisitorForm((prev) => ({ ...prev, [name]: value }));
  };

  const getSignatureData = () => {
    if (signatureMode === "draw") {
      if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
        return { signature_image: sigPadRef.current.toDataURL("image/png") };
      }
      return {};
    } else if (signatureMode === "type" && typedSignature) {
      return { signature_text: typedSignature };
    }
    return {};
  };

  const handleDriverSubmit = async () => {
    // Basic mandatory field validation before submit
    const missingFields = [];
    const hasDrawnSignature =
      signatureMode === "draw" &&
      sigPadRef.current &&
      !sigPadRef.current.isEmpty();
    const hasTypedSignature =
      signatureMode === "type" && typedSignature && typedSignature.trim();

    if (!hasDrawnSignature && !hasTypedSignature) {
      missingFields.push("Signature");
    }

    if (missingFields.length > 0) {
      toast.error(
        `Please fill all mandatory fields: ${missingFields.join(", ")}`
      );
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...driverForm,
        loading_or_unloading: loadingType,
        ...getSignatureData(),
      };

      // await axios.post(`${process.env.REACT_APP_RFS_URL}vehicle-management/save-driver`, payload,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      const res = await withDVRToken.post(`${process.env.REACT_APP_RFS_URL}vehicle-management/save-driver`, payload,);
      if (res.data?.response_code === 200) {
        setModalMessage("Driver saved successfully!");
        resetDriverForm();
        setShowModal(true);
        setTimeout(() => {
          setShowModal(false);
        }, 5000);
        setView("menu");
      } else {
        const msg = res.data?.response_msg || "Error saving driver";
        toast.error(msg);
        console.warn("Driver save business error:", res.data);
      }
    } catch (err) {
      console.error("Driver save error:", err.response?.data || err.message);
      toast.error("Error saving driver");
    } finally {
      setLoading(false);
    }
  };

  const handleVisitorSubmit = async () => {
    const missingFields = [];
    // Signature validation
    const hasDrawnSignature =
      signatureMode === "draw" &&
      sigPadRef.current &&
      !sigPadRef.current.isEmpty();
    const hasTypedSignature =
      signatureMode === "type" && typedSignature && typedSignature.trim();

    if (!hasDrawnSignature && !hasTypedSignature) {
      missingFields.push("Signature");
    }

    if (missingFields.length > 0) {
      toast.error(
        `Please fill all mandatory fields: ${missingFields.join(", ")}`
      );
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...visitorForm,
        ...getSignatureData(),
      };

      const res = await withDVRToken.post(
        `${process.env.REACT_APP_RFS_URL}vehicle-management/save-visitor`,
        payload
      );

      if (res.data?.response_code === 200) {
        setModalMessage("Visitor saved successfully!");
        resetVisitorForm();
        setShowModal(true);
        setTimeout(() => {
          setShowModal(false);
        }, 5000);
        setView("menu");
      } else {
        const msg = res.data?.response_msg || "Error saving visitor";
        toast.error(msg);
        console.warn("Visitor save business error:", res.data);
      }
    } catch (err) {
      console.error("Visitor save error:", err.response?.data || err.message);
      toast.error("Error saving visitor");
    } finally {
      setLoading(false);
    }
  };

  const resetDriverForm = () => {
    setDriverForm({
      company_name: "",
      first_name: "",
      surname: "",
      id_number: "",
      id_type: "",
      license: "",
      number: "",
      loading_or_unloading: "",
    });
    setDialCode("");
    setSignatureMode("draw");
    setTypedSignature("");
    if (sigPadRef.current) sigPadRef.current.clear();
    setLoadingType(""); // reset loading/unloading buttons
    setIsRulesAgreed(false);
    setIsAgreed(false);
  };

  const resetVisitorForm = () => {
    setVisitorForm({
      visitor_name: "",
      surname: "",
      company_name: "",
      license: "",
      person_to_meet: "",
      arrived_with_car: "",
      status: "1",
    });
    setDialCode("");
    setSignatureMode("draw");
    setTypedSignature("");
    if (sigPadRef.current) sigPadRef.current.clear();
    setIsRulesAgreed(false);
    setIsAgreed(false);
  };

  const handleBack = () => {
    if (view == 'visitor' || view == 'driver') {
      setView('menu')
    } else if (view == 'accept') {
      setView(acceptFor === 'driver' ? 'driver' : 'visitor')
    } else { }
  }
  const handleNext = (forWhom) => {
    if (forWhom == "driver") {
      const missingFields = [];
      if (!driverForm.company_name?.trim()) missingFields.push("Driver Company Name");
      if (!driverForm.first_name?.trim()) missingFields.push("Driver First Name");
      if (!driverForm.surname?.trim()) missingFields.push("Driver Last Name");
      if (!driverForm.id_type) missingFields.push("ID Type");
      if (!driverForm.id_expiry) missingFields.push("ID Expiry");
      // if (!dialCode) missingFields.push("Country Code");
      // const phoneLocal = driverForm.number
      //   ? (driverForm.number.split("-")[1] || "").trim()
      //   : "";
      // if (!phoneLocal) missingFields.push("Driver Phone No");
      if (!driverForm.license?.trim()) missingFields.push("License Plate No");
      // if (!driverForm.trailer_plate?.trim()) missingFields.push("Trailer ID Plate");
      if (!loadingType) missingFields.push("Loading/Unloading");
      if (!driverForm.cmr?.trim()) missingFields.push("CMR Ref No");

      if (missingFields.length > 0) {
        toast.error(
          `Please fill all mandatory fields: ${missingFields.join(", ")}`
        );
        return;
      }

    }
    else if (forWhom == "visitor") {
      const missingFields = [];
      // Validate all visitor fields from visitorFields array
      if (!visitorForm.visitor_name?.trim()) missingFields.push("Visitor Name");
      if (!visitorForm.company_name?.trim()) missingFields.push("Company");

      // Phone validation
      // if (!dialCode) missingFields.push("Country Code");
      // const phoneLocal = visitorForm.number
      //   ? (visitorForm.number.split("-")[1] || "").trim()
      //   : "";
      // if (!phoneLocal) missingFields.push("Phone No");

      // Arrived by car validation
      if (!visitorForm.arrived_with_car) missingFields.push("Arrived by Car");

      // License plate validation (only if arrived by car is "Yes")
      if (visitorForm.arrived_with_car === "Yes" && !visitorForm.license?.trim()) {
        missingFields.push("License Plate No");
      }
      if (missingFields.length > 0) {
        toast.error(
          `Please fill all mandatory fields: ${missingFields.join(", ")}`
        );
        return;
      }

    }
    setAcceptFor(forWhom)
    setView('accept')
  }
  const [isAgreed, setIsAgreed] = useState(false);
  const [isRulesAgreed, setIsRulesAgreed] = useState(false);
  const [acceptFor, setAcceptFor] = useState(null);

  const handleAgreement = (e) => {
    setIsAgreed(e.target.checked);
  };

  const handleRulesAgreement = (e) => {
    setIsRulesAgreed(e.target.checked);
  };
  const [logoutModal, setLogoutModal] = useState({
    show: false,
    loading: false,
    companyList: [],
    visitorList: [],
    filteredVisitors: [],
    selectedCompany: null,
    selectedVisitor: [],
    companySearch: "",
    visitorSearch: "",
  });

  // Helper — only updates the keys you pass
  const setLogout = (patch) => setLogoutModal(prev => ({ ...prev, ...patch }));

  const fetchLogoutData = async () => {
    try {
      const res = await withDVRToken.get('company-name-list');
      const raw = res?.data?.response_data || {};

      const companyList = Object.keys(raw).map(company => ({
        id: company,
        name: company,
      }));

      const visitorList = Object.entries(raw).flatMap(([company, visitors]) =>
        visitors.map(item => ({
          id: item.id,
          name: item.first_name,
          company: company,
        }))
      );

      setLogout({
        companyList,
        visitorList,
      });
    } catch (err) {
      console.error('Logout fetch error:', err);
      toast.error('Failed to load logout data');
    }
  };
  const closeLogoutModal = () =>
    setLogoutModal({
      show: false, loading: false,
      companyList: [], visitorList: [], filteredVisitors: [],
      selectedCompany: null, selectedVisitor: [],
      companySearch: "", visitorSearch: "",
    });
  const handleLogoutSubmit = async () => {
    const { selectedVisitor } = logoutModal;
    if (!selectedVisitor) {
      toast.error('Please select a visitor');
      return;
    }
    try {
      setLogout(prev => ({ ...prev, loading: true }));

      const now = new Date();
      const formattedDate = now.getFullYear() + '-' +
        String(now.getMonth() + 1).padStart(2, '0') + '-' +
        String(now.getDate()).padStart(2, '0') + ' ' +
        String(now.getHours()).padStart(2, '0') + ':' +
        String(now.getMinutes()).padStart(2, '0') + ':' +
        String(now.getSeconds()).padStart(2, '0');

      const payload = {
        id: [selectedVisitor.id],
        checkout_date: formattedDate,
      };


      const res = await withDVRToken.post(
        `${process.env.REACT_APP_RFS_URL}company-name-list-save`,
        payload
      );
      if (res.data?.response_code === 200) {
        toast.success(res.data?.response_msg || 'Logged out successfully');
        closeLogoutModal();
      } else {
        toast.error(res.data?.response_msg || 'Logout failed');
      }
    } catch (err) {
      toast.error('Error during logout');
    } finally {
      setLogout(prev => ({ ...prev, loading: false }));
    }
  };

  return (
    <Container
      className='driver_register_master_dv'
    >
      {console.log("visitorForm", visitorForm)}
      {/* MENU VIEW */}
      {view === "menu" && (
        <div>
          <div className="text-center">
            <img src={authData?.orgLogo} alt="logo_blue" style={{ width: '150px' }} className='mt-5 mb-5' />
          </div>


          <Container className="d-flex flex-column align-items-center ">
            {visibleCards.map((crd, index) => (
              < Card
                className="mb-3 text-center border-0 registration_dv"
                key={`m_${index}`}
                style={{
                  width: "100%",
                  cursor: "pointer",
                  background: "#F6F6F6",
                }}
                onClick={() => cardClick(crd.name)}
              >
                <Card.Body>
                  <Card.Title className='text-start'>
                    <h5>{crd.title}</h5>
                  </Card.Title>
                  <p className='w-50 mb-0'>{crd.sub}</p>
                  <div className='text-end imgs'>
                    <img src={crd.img} style={{ marginBottom: "10px" }} />
                  </div>
                </Card.Body>
              </Card>
            ))}
            {authData?.person == "V" && (
              <Button
                variant="outline-danger"
                className="w-100 mt-2"
                onClick={() => { fetchLogoutData(); setLogout({ show: true }); }}
              >
                Logout
              </Button>)}
          </Container>
        </div>
      )
      }

      {/* DRIVER REGISTRATION FORM */}
      {
        view === "driver" && (
          <Card className="driver">
            {/* Gradient Header */}
            <div className="gradient_hdr_dv">
              <Button
                variant="link"
                onClick={() => setView("menu")}
                className="back_btn me-4"
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </Button>
              <span className='ms-5'>
                <img src={authData?.orgLogo} style={{ width: '150px' }} alt="logo_blue" className='logoIcon' />
              </span>
              {/* <h5 className="mt-5 mb-0 text-dark">Driver Registration</h5> */}


            </div>

            {/* White Body */}
            <Card.Body style={{ background: "white", borderRadius: "12px" }}>
              <Form className="pt-0">
                <h3 class="text-dark"> 1. Company & Driver Details</h3>
                {/* Driver Name */}
                <Form.Group className="mb-3">
                  <Form.Label>Company Name<span className="text-danger">*</span> </Form.Label>
                  <Form.Control
                    type="text"
                    name="company_name"
                    value={driverForm.company_name}
                    onChange={handleDriverChange}
                  // placeholder="Driver name"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Driver First Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="first_name"
                    value={driverForm.first_name}
                    onChange={handleDriverChange}
                  // placeholder="Driver name"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Driver Last Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="surname"
                    value={driverForm.surname}
                    onChange={handleDriverChange}
                  // placeholder="Driver name"
                  />
                </Form.Group>
                <div className='d-flex mb-3'>
                  <Form.Group style={{ width: '40%' }}>
                    <Form.Label>ID Type <span className="text-danger">*</span></Form.Label>
                    <InputGroup>
                      <div className='phone_code'>
                        <Select
                          options={idTypeOptions}
                          // filterOption={filterPhoneOption}
                          // placeholder="ID Type"
                          value={idTypeOptions.find(o => o.value === driverForm?.id_type) || null}
                          onChange={(opt) => {
                            setDriverForm(prev => ({
                              ...prev,
                              id_type: opt ? opt.value : ''
                            }));
                          }}
                          isClearable
                        />
                      </div>
                    </InputGroup>
                  </Form.Group>
                  <Form.Group style={{ width: '60%' }}>
                    <Form.Label>ID Expiry <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="date"
                      name="id_expiry"
                      value={driverForm.id_expiry}
                      onChange={handleDriverChange}
                    />
                  </Form.Group>

                </div>
                {/* <div className='d-flex mb-3'>
                  <Form.Group style={{ width: '40%' }}>
                    <Form.Label>Country Code <span className="text-danger">*</span></Form.Label>
                    <InputGroup>
                      <div className='phone_code'>
                        <Select
                          options={phoneOptions}
                          filterOption={filterPhoneOption}
                          // placeholder="Code"
                          value={phoneOptions.find(o => o.value === dialCode) || null}
                          onChange={(opt) => {
                            const newCode = opt ? opt.value : '';
                            setDialCode(newCode);
                            const local = driverForm.number ? (driverForm.number.split('-')[1] || '') : '';
                            setDriverForm(prev => ({ ...prev, number: newCode ? `${newCode}-${local}` : local }));
                          }}
                          isClearable
                        />
                      </div>
                    </InputGroup>
                  </Form.Group>
                  <Form.Group style={{ width: '60%' }}>
                    <Form.Label>Driver Phone No. <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="tel"
                      name="number"
                      value={driverForm.number ? (driverForm.number.split('-')[1] || '') : ''}
                      onChange={(e) => {
                        const local = e.target.value;
                        const code = dialCode || '';
                        setDriverForm(prev => ({ ...prev, number: code ? `${code}-${local}` : local }));
                      }}
                      // placeholder="612345678"
                      inputMode="numeric"
                    />
                  </Form.Group>
                </div> */}


                {/* ID Type */}
                {/* <Form.Group className="mb-3">
                  <Form.Label>ID Type</Form.Label>
                  <Select
                    options={idTypeOptions}
                    placeholder="Select"
                    value={idTypeOptions.find(opt => opt.value === driverForm.id_type) || null}
                    onChange={(opt) => setDriverForm(prev => ({ ...prev, id_type: opt?.value }))}
                  />
                </Form.Group> */}
                {/* <Form.Group className="mb-3">
                  <Form.Label>ID Type</Form.Label>

                  <div className="radio-card-group">
                    {idTypeOptions.map(opt => {
                      const radioId = `id_type_${opt.value}`;

                      return (
                        <Form.Check
                          inline
                          key={opt.value}
                          type="radio"
                          id={radioId}
                          label={opt.label}
                          name="id_type"
                          value={opt.value}
                          checked={driverForm.id_type === opt.value}
                          onChange={() =>
                            setDriverForm(prev => ({ ...prev, id_type: opt.value }))
                          }
                        />
                      );
                    })}
                  </div>


                </Form.Group> */}


                <h3 class="text-dark">2. Vehicle Information</h3>
                {/* License */}
                <div className='d-flex mb-3'>
                  <Form.Group style={{ width: '50%', margin: '0 10px 0 0' }}>
                    <Form.Label>License Plate No. <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="license"
                      value={driverForm.license}
                      onChange={handleDriverChange}
                    // placeholder="License plate no."
                    />
                  </Form.Group>
                  <Form.Group style={{ width: '50%', margin: '0 10px 0 0' }}>
                    <Form.Label>Trailer ID Plate <span className="text-danger"></span></Form.Label>
                    <Form.Control
                      type="text"
                      name="trailer_plate"
                      value={driverForm.trailer_plate}
                      onChange={handleDriverChange}
                    // placeholder="Trailer ID Plate"
                    />
                  </Form.Group>
                </div>
                <h3 class="text-dark">3. Activity</h3>
                {/* <Form.Group className="mb-3">
                  <Form.Label>Trucker ID Plate</Form.Label>
                  <Form.Control
                    type="text"
                    name="trucker_plate"
                    value={driverForm.trucker_plate}
                    onChange={handleDriverChange}
                    placeholder="Trucker ID Plate"
                  />
                </Form.Group> */}


                {/* Loading / Unloading */}
                <Form.Group className="mb-2 mt-1">
                  {/* <Form.Label>Loading/Unloading</Form.Label> */}
                  <div className="d-flex gap-2">
                    <Button
                      variant={loadingType === "Loading" ? "secondary" : "outline-secondary"}
                      onClick={() => setLoadingType("Loading")}
                      style={{ flex: 1 }}
                      className="loading_unloading_btn"
                    >
                      <img src={loading_icon} alt='loading' className='loading_icon pe-2' />
                      Loading
                    </Button>
                    <Button
                      variant={loadingType === "Unloading" ? "secondary" : "outline-secondary"}
                      onClick={() => setLoadingType("Unloading")}
                      style={{ flex: 1 }}
                      className="loading_unloading_btn"
                    >
                      <img src={unloading_icon} alt='unloading' className='loading_icon pe-2' />
                      Unloading
                    </Button>
                  </div>
                </Form.Group>
                <Form.Group className='mt-3'>
                  <Form.Label>Document Reference <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="cmr"
                    value={driverForm.cmr}
                    onChange={handleDriverChange}
                  // placeholder="CMR Reference Number"
                  />
                </Form.Group>
                {/* Signature */}
                {/* <Form.Group className="mb-2">
                  <Form.Label>Signature</Form.Label>
                  {signatureMode === "draw" ? (
                    <div
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        background: "#f9f9f9",
                      }}
                    >
                      <SignatureCanvas
                        ref={sigPadRef}
                        penColor="black"
                        canvasProps={{
                          width: 420,
                          height: 150,
                          className: "sigCanvas",
                        }}
                      />
                      <Button
                        size="sm"
                        variant="light"
                        className="mt-2"
                        onClick={() => sigPadRef.current.clear()}
                      >
                        <FontAwesomeIcon icon={faEraser} />
                      </Button>
                    </div>
                  ) : (
                    <Form.Control
                      type="text"
                      placeholder="Type your signature"
                      value={typedSignature}
                      onChange={(e) => setTypedSignature(e.target.value)}
                      className="type_sign"
                    />
                  )}
                  <Row className="mt-3">
                    <Col>
                      <Button
                        variant={signatureMode === "draw" ? "secondary" : "outline-secondary"}
                        size="sm"
                        className="w-100 loading_unloading_btn"
                        onClick={() => setSignatureMode("draw")}
                      >
                        Draw Signature
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        variant={signatureMode === "type" ? "secondary" : "outline-secondary"}
                        size="sm"
                        className="w-100 loading_unloading_btn"
                        onClick={() => setSignatureMode("type")}
                      >
                        Typing Signature
                      </Button>
                    </Col>
                  </Row>
                </Form.Group> */}

                {/* Next Button */}
                <div className="submit_cancel_btn">
                  <div className="d-flex" style={{ gap: "10px" }}>
                    <Button variant="primary" className="w-100 mt-0" onClick={() => handleNext('driver')}>
                      Next
                    </Button>
                  </div>
                </div>

              </Form>
            </Card.Body>
          </Card>

        )
      }

      {/* VISITOR REGISTRATION FORM */}
      {
        view === "visitor" && (
          <Card className="driver drivers">
            {/* Gradient Header */}
            <div className="gradient_hdr_dv">
              <Button variant="link" onClick={handleBack} className="back_btn me-4">
                <FontAwesomeIcon icon={faArrowLeft} />
              </Button>
              <span className='ms-5'>
                <img src={authData?.orgLogo} style={{ width: '150px' }} alt="logo_blue" />
              </span>
              <h5 className="mt-5 mb-0 text-dark">Visitor Registration</h5>
              <p className='visitor_text'>Please share your details to complete visitor registration</p>
            </div>
            {/* White Body */}
            <Card.Body style={{ background: "white", borderRadius: "12px" }}>
              <Form>
                {visitorFields.map((frm, index) => (
                  <Form.Group className="mb-3" key={`v_${index}`}>
                    <Form.Label>{frm.label} <span className="text-danger">*</span></Form.Label>
                    {frm.name === 'number' ? (
                      <InputGroup>
                        <div className='phone_code' style={{ width: '40%' }}>
                          <Select
                            options={phoneOptions}
                            filterOption={filterPhoneOption}
                            placeholder="Code"
                            value={phoneOptions.find(o => o.value === dialCode) || null}
                            onChange={(opt) => {
                              const newCode = opt ? opt.value : '';
                              setDialCode(newCode);
                              const local = visitorForm.number ? (visitorForm.number.split('-')[1] || '') : '';
                              setVisitorForm(prev => ({ ...prev, number: newCode ? `${newCode}-${local}` : local }));
                            }}
                            isClearable
                          />
                        </div>
                        <Form.Control
                          type="tel"
                          name={frm.name}
                          value={visitorForm.number ? (visitorForm.number.split('-')[1] || '') : ''}
                          onChange={(e) => {
                            const local = e.target.value;
                            const code = dialCode || '';
                            setVisitorForm(prev => ({ ...prev, number: code ? `${code}-${local}` : local }));
                          }}
                          placeholder={frm.ph}
                          inputMode="numeric"
                          style={{ borderRadius: '8px' }}
                        />
                      </InputGroup>
                    ) : (
                      <Form.Control
                        type={frm.type}
                        name={frm.name}
                        value={visitorForm[frm.name]}
                        onChange={handleVisitorChange}
                        placeholder={frm.ph}
                        style={{ borderRadius: '8px' }}
                      />
                    )}
                  </Form.Group>
                ))}
                <Form.Group className="mb-3">
                  <Form.Label>Appointment With</Form.Label>
                  {/* <Select
                    options={userList}
                    onChange={(selected) => {
                      const updatedData = { ...visitorForm, person_to_meet: selected.value };
                      setVisitorForm(updatedData);
                    }}
                    placeholder="Select"
                    className=''
                    filterOption={customFilter}
                    isClearable
                    menuIsOpen={undefined}
                    name="person_to_meet"
                    value={userList.find(option => option.value === visitorForm.person_to_meet)}
                  /> */}
                  <div className={searchText.length < 3 ? "hide-no-results" : ""}>
                    <style>
                      {`
                        .hide-no-results .sc-gEvEer.ffXrxx {
                          display: none !important;
                        }
                      `}
                    </style>
                    <ReactSearchAutocomplete
                      items={userList}
                      onSelect={handleOnSelect}
                      onSearch={(string) => {
                        setSearchText(string);
                      }}
                      autoFocus
                      placeholder="Appointment With"
                      fuseOptions={{
                        shouldSort: true,
                        threshold: 0.0, // exact match required at start
                        location: 0,    // start of string
                        distance: 0,
                        minMatchCharLength: 3,
                        keys: ["name"]
                      }}
                      styling={{
                        resultsContainer: {
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          zIndex: 9999
                        },
                        resultItem: {
                          padding: "10px",
                          cursor: "pointer"
                        },
                        resultItemHover: {
                          backgroundColor: "#f0f0f0"
                        }
                      }}
                    />
                  </div>
                  {/* <Form.Control
                  type="text"
                  name="person_to_meet"
                  value={visitorForm.person_to_meet}
                  onChange={handleVisitorChange}
                  placeholder="Appointment with"
                /> */}
                </Form.Group>
                {/* <Form.Group className="mb-3">
                  <Form.Label>Visitor Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="visitor_name"
                    value={visitorForm.visitor_name}
                    onChange={handleVisitorChange}
                    placeholder="Visitor name"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Company</Form.Label>
                  <Form.Control
                    type="text"
                    name="company_name"
                    value={visitorForm.company_name}
                    onChange={handleVisitorChange}
                    placeholder="Company name"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>License Plate No.</Form.Label>
                  <Form.Control
                    type="text"
                    name="license"
                    value={visitorForm.license}
                    onChange={handleVisitorChange}
                    placeholder="License plate no."
                  />
                </Form.Group> */}
                <Form.Group className="mb-3 sl_status">
                  <Form.Label>Arrived by Car <span className="text-danger">*</span></Form.Label>
                  <div className='radio-card-group'>
                    <Form.Check
                      inline
                      label="Yes"
                      type="radio"
                      id="arrived_yes"
                      value="Yes"
                      name="arrived_with_car"
                      checked={visitorForm.arrived_with_car === "Yes"}
                      onChange={(e) =>
                        setVisitorForm((prev) => ({
                          ...prev,
                          arrived_with_car: e.target.value,
                        }))
                      }
                    />
                    <Form.Check
                      inline
                      label="No"
                      type="radio"
                      id="arrived_no"
                      value="No"
                      name="arrived_with_car"
                      checked={visitorForm.arrived_with_car === "No"}
                      onChange={(e) =>
                        setVisitorForm((prev) => ({
                          ...prev,
                          arrived_with_car: e.target.value,
                          license: "", // clear license if "No"
                        }))
                      }
                    />
                  </div>
                </Form.Group>



                {visitorForm.arrived_with_car === "Yes" && (
                  <Form.Group className="mb-3">
                    <Form.Label>License Plate No. <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="license"
                      value={visitorForm.license}
                      onChange={handleVisitorChange}
                      placeholder="License plate no."
                    />
                  </Form.Group>
                )}

                {/* Signature */}
                {/* <Form.Group className="mb-3">
                  <Form.Label>Signature</Form.Label>
                  {signatureMode === "draw" ? (
                    <div style={{ border: "1px solid #ddd", borderRadius: "8px", background: "#f9f9f9", }}>

                      <SignatureCanvas ref={sigPadRef} penColor="black" canvasProps={{ width: 420, height: 150, className: "sigCanvas", }} />
                      <Button size="sm" variant="light" className="mt-2" onClick={() => sigPadRef.current.clear()}>
                        <FontAwesomeIcon icon={faEraser} />
                      </Button>
                    </div>
                  ) : (
                    <Form.Control
                      type="text"
                      placeholder="Type your signature"
                      className="type_sign"
                      value={typedSignature}
                      onChange={(e) =>
                        setTypedSignature(e.target.value)}
                    />
                  )}
                  <Row className="mt-3">
                    <Col>
                      <Button
                        variant={
                          signatureMode === "draw"
                            ? "secondary"
                            : "outline-secondary"
                        }
                        size="sm"
                        className="w-100 loading_unloading_btn"
                        onClick={() => setSignatureMode("draw")}
                      >
                        Draw Signature
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        variant={
                          signatureMode === "type"
                            ? "secondary"
                            : "outline-secondary"
                        }
                        size="sm"
                        className="w-100 loading_unloading_btn"
                        onClick={() => setSignatureMode("type")}
                      >
                        Typing Signature
                      </Button>
                    </Col>
                  </Row>
                </Form.Group> */}
                {/* Buttons */}
                <div className="submit_cancel_btn">
                  <div className="d-flex" style={{ gap: "10px" }}>
                    <Button variant="primary" className="w-100 mt-3" onClick={() => handleNext('visitor')}>
                      Next
                    </Button>
                  </div>
                </div>
              </Form>
            </Card.Body>
          </Card>
        )
      }
      {
        view === "accept" && (
          <Card className="driver">
            {/* Gradient Header */}
            <div className="gradient_hdr_dv">
              <Button variant="link" onClick={handleBack} className="back_btn me-4">
                <FontAwesomeIcon icon={faArrowLeft} />
              </Button>
              <span className='ms-5'>
                <img src={authData?.orgLogo} style={{ width: '150px' }} alt="logo_blue" />
              </span>
              {acceptFor === 'driver' && (
                <>
                  {/* Welcome to KLN Freight (Netherlands) B.V. */}
                  <p className="mt-4 mb-0 text-dark">Welcome to  {authData?.orgName} Freight</p>
                  <Card.Body style={{ background: "white", borderRadius: "12px" }}>
                    <ul className='text-dark mb-0'>
                      <li>Access is only permitted with authorization from  {authData?.orgName} personnel.</li>
                      <li>Safety shoes and a safety vest are mandatory.</li>
                      <li>Always follow the safety instructions and floor markings.</li>
                      <li>Smoking, eating, drinking, and mobile phone use are not allowed in the warehouse.</li>
                      <li>Stay alert for moving equipment (such as forklifts and pallet trucks)</li>
                      <li>In case of an emergency, follow the instructions of our emergency response staff (BHV).</li>
                    </ul>
                  </Card.Body>
                </>
              )}
              <h6 className="mb-0 text-dark mt-4">Privacy Statement</h6>

            </div>
            {/* White Body */}
            <Card.Body style={{ background: "white", borderRadius: "12px", padding: '5px 15px' }}>

              {/* <Form.Group className="mb-3">
                
                <Form.Check
                  type="checkbox"
                  id="checkbox"
                  name=''
                  label='The personal data requested in this form is processed for access control and
                security purposes, under the supervision of the Royal Netherlands Marechaussee.
                The data is used exclusively for security purposes, may be accessed by authorized authorities,
                and is retained in accordance with the statutory retention period.'
                  checked={isAgreed}
                  onChange={handleAgreement}
                />
              </Form.Group> */}
              <p className='mt-0 privacy_text'>The personal data requested in this form is processed for access control and
                security purposes, under the supervision of the Royal Netherlands Marechaussee.
                The data is used exclusively for security purposes, may be accessed by authorized authorities,
                and is retained in accordance with the statutory retention period.</p>

              <Form.Group className="mb-2">
                <Form.Label>Signature <span className="text-danger">*</span></Form.Label>
                {signatureMode === "draw" ? (
                  <div
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      background: "#f9f9f9",
                    }}
                  >
                    <SignatureCanvas
                      ref={sigPadRef}
                      penColor="black"
                      canvasProps={{
                        width: 420,
                        height: 150,
                        className: "sigCanvas",
                      }}
                    />
                    <Button
                      size="sm"
                      variant="light"
                      className="mt-2"
                      onClick={() => sigPadRef.current.clear()}
                    >
                      <FontAwesomeIcon icon={faEraser} />
                    </Button>
                  </div>
                ) : (
                  <Form.Control
                    type="text"
                    placeholder="Type your signature"
                    value={typedSignature}
                    onChange={(e) => setTypedSignature(e.target.value)}
                    className="type_sign"
                  />
                )}
                <Row className="mt-3">
                  <Col>
                    <Button
                      variant={signatureMode === "draw" ? "secondary" : "outline-secondary"}
                      size="sm"
                      className="w-100 loading_unloading_btn"
                      onClick={() => setSignatureMode("draw")}
                    >
                      Draw Signature
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      variant={signatureMode === "type" ? "secondary" : "outline-secondary"}
                      size="sm"
                      className="w-100 loading_unloading_btn"
                      onClick={() => setSignatureMode("type")}
                    >
                      Typing Signature
                    </Button>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mt-4">
                {/* <Form.Label>{frm.label}</Form.Label> */}
                <Form.Check
                  type="checkbox"
                  id="rules_checkbox"
                  name='rules_agreement'
                  label='"I agree", you confirm that you have read and will comply with these rules during your presence in the warehouse.'
                  checked={isRulesAgreed}
                  onChange={handleRulesAgreement}
                  className='w-100'
                />
              </Form.Group>

              <div className="submit_cancel_btn">
                <div className="d-flex" style={{ gap: "10px" }}>
                  {/* <Button variant="secondary" onClick={handleBack} style={{ width: "50%" }}> Back </Button> */}
                  <Button
                    variant={(acceptFor === 'driver' ? (isRulesAgreed && isAgreed) : isAgreed) ? 'primary' : 'primary'}
                    className="w-100 mt-3"
                    onClick={isRulesAgreed ? (acceptFor === 'driver' ? handleDriverSubmit : handleVisitorSubmit) : () => { }}
                    disabled={isRulesAgreed ? false : true}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </Card.Body>
          </Card>
        )
      }

      {/* SUCCESS / ERROR MODAL */}
      <Modal className="addfrom change_type" show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <h5>{modalMessage}</h5>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      <Modal show={logoutModal.show} onHide={closeLogoutModal} centered className="addfrom change_type">
        <Modal.Header closeButton>
          <Modal.Title>Logout</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-4">
            <Form.Label>Company Name <span className="text-danger">*</span></Form.Label>
            <div className={logoutModal.companySearch.length < 1 ? "hide-no-results" : ""}>
              <ReactSearchAutocomplete
                items={logoutModal.companyList}
                inputSearchString={logoutModal.companySearch}
                onSearch={(str) => setLogout({ companySearch: str })}
                onSelect={(item) => setLogout({
                  selectedCompany: item,
                  filteredVisitors: logoutModal.visitorList.filter(v => v.company === item.name),
                  selectedVisitor: null,
                  visitorSearch: "",
                })}
                onClear={() => setLogout({
                  selectedCompany: null, filteredVisitors: [],
                  selectedVisitor: null, visitorSearch: "",
                })}
                placeholder="Search company..."
                fuseOptions={{ shouldSort: true, threshold: 0.3, keys: ["name"] }}
                styling={{
                  resultsContainer: { backgroundColor: "#fff", border: "1px solid #ddd", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", zIndex: 9999 },
                  resultItem: { padding: "10px", cursor: "pointer" },
                  resultItemHover: { backgroundColor: "#f0f0f0" },
                }}
              />
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Visitor <span className="text-danger">*</span></Form.Label>
            <div
              className={logoutModal.visitorSearch.length < 1 ? "hide-no-results" : ""}
              style={{
                opacity: logoutModal.selectedCompany ? 1 : 0.45,
                pointerEvents: logoutModal.selectedCompany ? "auto" : "none",
              }}
            >
              <ReactSearchAutocomplete
                items={logoutModal.filteredVisitors}
                inputSearchString={logoutModal.visitorSearch}
                onSearch={(str) => setLogout({ visitorSearch: str })}
                onSelect={(item) => setLogout({ selectedVisitor: item })}
                onClear={() => setLogout({ selectedVisitor: null, visitorSearch: "" })}
                placeholder={logoutModal.selectedCompany ? "Search visitor..." : "Select a company first"}
                fuseOptions={{ shouldSort: true, threshold: 0.3, keys: ["name"] }}
                styling={{
                  resultsContainer: { backgroundColor: "#fff", border: "1px solid #ddd", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", zIndex: 9998 },
                  resultItem: { padding: "10px", cursor: "pointer" },
                  resultItemHover: { backgroundColor: "#f0f0f0" },
                }}
              />
            </div>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={closeLogoutModal} disabled={logoutModal.loading}>Cancel</Button>
            <Button
              variant="primary"
              onClick={handleLogoutSubmit}
              disabled={logoutModal.loading || !logoutModal.selectedCompany || !logoutModal.selectedVisitor}
            >
              {logoutModal.loading ? <Spinner animation="border" size="sm" /> : "Logout"}
            </Button></div>
        </Modal.Footer>
      </Modal>
      {
        loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255, 255, 255, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 2000,
            }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        )
      }
    </Container >
  );
};

export default DriverVisitorRegistration;
